import React from "react";

type TitleHelpContentProps = {
  description: string;
  supportedOptions: string[];
};
export const TitleHelpContent: React.FC<TitleHelpContentProps> = ({
  description,
  supportedOptions,
}) => {
  return (
    <div className="font-inter-normal-12px">
      <p>{description}</p>
      <ul className="list-inside list-disc">
        {supportedOptions.map((option, index) => (
          <li key={option + index}>{option}</li>
        ))}
      </ul>
      <p>Usage limits apply. Human verification is required for changes.</p>
      <a
        className="underline"
        href="https://docs.taktile.com/decision-flow-fundamentals/taktile-copilot"
        rel="noreferrer"
        target="_blank"
      >
        Learn more
      </a>
    </div>
  );
};
